import React, { useRef } from 'react';

const HIGHLIGHT_REGEX = /(\*\*[^*]+\*\*)/g;

// ── מפרק **הדגשה** (markdown פשוט) לרינדור — אותה מוסכמה בדיוק כמו
// HighlightedText.tsx באפליקציית react-app, כי שתי הפלטפורמות כותבות/קוראות
// את אותו hakdashot.value גולמי מה-DB. ──
export const renderHighlighted = (text) => {
  if (!text) return null;
  return text
    .split(HIGHLIGHT_REGEX)
    .filter(Boolean)
    .map((part, i) =>
      part.startsWith('**') && part.endsWith('**') && part.length > 4
        ? <b key={i} style={{ color: '#C9A84C' }}>{part.slice(2, -2)}</b>
        : <React.Fragment key={i}>{part}</React.Fragment>
    );
};

// טקסטאריה עם כפתור "הדגשה" — עוטף את הטקסט המסומן ב-**, ומציג תצוגה מקדימה
// חיה. אם הבחירה כבר עטופה ב-** משני הצדדים, ההדגשה מוסרת במקום עטיפה כפולה.
export default function HighlightableTextarea({ value, onChange, rows = 3, placeholder, style }) {
  const ref = useRef(null);

  const toggleHighlight = () => {
    const el = ref.current;
    if (!el) return;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    if (start === end) return;

    const before = value.slice(0, start);
    const selected = value.slice(start, end);
    const after = value.slice(end);

    let next, newStart, newEnd;
    if (before.endsWith('**') && after.startsWith('**')) {
      next = before.slice(0, -2) + selected + after.slice(2);
      newStart = start - 2;
      newEnd = end - 2;
    } else {
      next = `${before}**${selected}**${after}`;
      newStart = start + 2;
      newEnd = end + 2;
    }
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(newStart, newEnd);
    });
  };

  return (
    <div>
      <div style={s.toolbar}>
        <button type="button" onClick={toggleHighlight} style={s.boldBtn}>הדגשה **</button>
        <span style={s.hint}>סמנו טקסט ולחצו כדי להבליט חלק מההקדשה</span>
      </div>
      <textarea
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        placeholder={placeholder}
        style={{ ...s.textarea, ...style }}
      />
      {!!value && (
        <div style={s.preview}>
          <div style={s.previewLabel}>תצוגה מקדימה</div>
          <div style={s.previewText}>{renderHighlighted(value)}</div>
        </div>
      )}
    </div>
  );
}

const s = {
  toolbar: { display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', gap: 10, marginBottom: 6 },
  boldBtn: { padding: '4px 10px', borderRadius: 8, border: '1px solid rgba(201,168,76,0.4)', background: 'rgba(201,168,76,0.12)', color: '#8a6d1f', fontSize: 12, fontWeight: 'bold', cursor: 'pointer' },
  hint: { fontSize: 11, color: '#94A3B8' },
  textarea: { width: '100%', padding: '10px', fontFamily: 'Arial, sans-serif', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px', direction: 'rtl', boxSizing: 'border-box', resize: 'vertical' },
  preview: { marginTop: 6, padding: '8px 10px', background: '#FBF7EC', border: '1px solid rgba(201,168,76,0.25)', borderRadius: 8 },
  previewLabel: { fontSize: 10, color: '#94A3B8', marginBottom: 4 },
  previewText: { fontSize: 13, color: '#333', lineHeight: 1.5, whiteSpace: 'pre-wrap' },
};
